import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CalendarBlank, X, ArrowRight, CheckCircle } from '@phosphor-icons/react';

const DISMISS_KEY = 'booking_promo_banner_dismissed';

const COPY = {
  homeowner: {
    title: 'New: Book pros by calendar',
    body: 'See real availability on every pro\u2019s profile \u2014 tap the open days you need and send a booking request in two taps. No more phone tag.',
    cta: 'Browse Available Pros',
    to: '/browse-worker-teams',
  },
  contractor: {
    title: 'New: Get booked by calendar',
    body: 'Set your availability once \u2014 homeowners see your open days, request dates, and you confirm with one tap. Confirmed dates auto-block on your calendar.',
    cta: 'Set My Availability',
    to: '/my-availability',
  },
  worker: {
    title: 'New: Get booked by calendar',
    body: 'Set your open days once \u2014 clients request the dates they need and you accept with one tap right in chat. Booked days lock automatically.',
    cta: 'Set My Availability',
    to: '/my-availability',
  },
};

export const BookingPromoBanner = ({ role = 'homeowner' }) => {
  const navigate = useNavigate();
  const [dismissed, setDismissed] = useState(() => localStorage.getItem(DISMISS_KEY) === '1');
  if (dismissed) return null;

  const { title, body, cta, to } = COPY[role] || COPY.homeowner;

  const dismiss = () => {
    localStorage.setItem(DISMISS_KEY, '1');
    setDismissed(true);
  };

  return (
    <div
      className="relative mb-6 bg-[#FEF08A] border-4 border-[#0F172A] shadow-[6px_6px_0px_#0F172A] overflow-hidden"
      data-testid="booking-promo-banner"
    >
      <button
        onClick={dismiss}
        aria-label="Dismiss booking promo"
        className="absolute top-2 right-2 z-10 w-8 h-8 flex items-center justify-center bg-white hover:bg-[#F0EDE6] text-[#0F172A] border-2 border-[#0F172A] transition-colors"
        data-testid="booking-promo-dismiss-btn"
      >
        <X size={16} weight="bold" />
      </button>

      <div className="flex flex-col md:flex-row md:items-center gap-4 px-5 py-4 pr-12">
        <div className="hidden sm:flex w-12 h-12 shrink-0 items-center justify-center bg-[#2563EB] border-2 border-[#0F172A] shadow-[3px_3px_0px_#0F172A]">
          <CalendarBlank size={24} weight="fill" className="text-[#0F172A]" />
        </div>

        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 flex-wrap mb-1">
            <span className="inline-flex items-center gap-1 bg-[#3B82F6] text-[#0F172A] text-[10px] font-black uppercase tracking-widest px-2 py-0.5 border border-[#0F172A]">
              <CheckCircle size={11} weight="fill" /> New Feature
            </span>
            <h3 className="text-[#0F172A] font-black uppercase text-sm md:text-base tracking-tight">{title}</h3>
          </div>
          <p className="text-[#5C5C5C] text-sm leading-snug">{body}</p>
        </div>

        <button
          onClick={() => navigate(to)}
          className="shrink-0 inline-flex items-center justify-center gap-2 px-5 py-2.5 bg-[#3B82F6] text-[#0F172A] font-black uppercase text-xs tracking-wide border-2 border-[#0F172A] shadow-[3px_3px_0px_#0F172A] hover:-translate-y-0.5 transition-transform"
          data-testid="booking-promo-banner-cta"
        >
          {cta} <ArrowRight size={14} weight="bold" />
        </button>
      </div>
    </div>
  );
};

export default BookingPromoBanner;
